import { VStack, Heading, Stack, Button, Text, Box, Image } from '@chakra-ui/react'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import React, { ReactNode } from 'react'
import { LuChevronLeft } from 'react-icons/lu'

interface InteriorHeroProps {
  imageUrl?: string
  imageAlt?: string
  title: ReactNode
  description?: string
  bgColor?: string
  showBackButton?: boolean
  centerContent?: boolean
  buttonText?: string
  buttonUrl?: string
}

const InteriorHero: React.FC<InteriorHeroProps> = ({
  imageUrl,
  imageAlt,
  title,
  description,
  showBackButton,
  centerContent,
  buttonText,
  buttonUrl,
}) => {
  const { getBreakpointValue } = useBreakpointContext()

  return (
    <Stack
      align={'center'}
      gap={getBreakpointValue([10, 20])}
      justify={'center'}
      maxWidth={'80em'}
      width={'full'}
      direction={
        centerContent
          ? getBreakpointValue(['column', 'column'])
          : getBreakpointValue(['column', 'column', 'row'])
      }
    >
      <VStack align={centerContent ? 'center' : 'flex-start'} flex={1} gap={getBreakpointValue([3, 4, 8])}>
        <Button
          colorPalette={'teal'}
          display={showBackButton ? 'flex' : 'none'}
          size={'sm'}
          variant={'ghost'}
          onClick={() => window.history.back()}
        >
          <LuChevronLeft />
          Back
        </Button>
        <Heading
          background={'linear-gradient(90deg, #d97258 0%, #9858a3 100%)'}
          backgroundClip={'text'}
          color={'transparent'}
          padding={1}
          size={getBreakpointValue(['3xl', '4xl', '5xl'])}
          textAlign={centerContent ? 'center' : 'left'}
        >
          {title}
        </Heading>
        {description && (
          <Text
            color={'fg.DEFAULT'}
            fontSize={getBreakpointValue(['md', 'lg', 'xl'])}
            maxWidth={'container.md'}
            textAlign={centerContent ? 'center' : 'left'}
          >
            {description}
          </Text>
        )}
        {buttonText && (
          <NextLink href={buttonUrl} prefetch={false}>
            <Button bgColor={'action.active'} color={'bg.DEFAULT'} size={'lg'}>
              {buttonText}
            </Button>
          </NextLink>
        )}
      </VStack>
      {imageUrl && (
        <VStack flex={2} gap={10}>
          <Box width={'full'}>
            <Image alt={imageAlt} src={imageUrl} />
          </Box>
        </VStack>
      )}
    </Stack>
  )
}

export default InteriorHero
